import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { User } from 'src/app/models/user-model/user.model';
import { MatDialog } from '@angular/material/dialog';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-users-user-resume-card',
  templateUrl: './users-user-resume-card.component.html',
  styleUrls: ['./users-user-resume-card.component.scss']
})
export class UsersUserResumeCardComponent implements OnInit, OnDestroy {

  @Input() user: User;
  @Input() viewDisposition;
  deleteUserSubscription: Subscription;

  constructor(private router: Router,
    private userStorageService: UserStorageService,
    private dialog: MatDialog,
    private snackbarService: SnackBarService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() { }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['../../user', this.user.InternalId], { relativeTo: this.activatedRoute });
    }
  }

  public deleteUser() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['users-page.delete user', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteUserSubscription = this.userService.deleteUser(this.user.InternalId).subscribe(
          (res) => {
            this.userService.refreshUsers();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  ngOnDestroy() {
    if (this.deleteUserSubscription) { this.deleteUserSubscription.unsubscribe(); }
  }

}
